import React from 'react';
import styled from 'styled-components';

import { DotLoadingIndicator } from '@xingternal/dot-loading-indicator';
import { Column } from '@xingternal/xing-grid';

type Props = {
  testId?: string;
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 66vh;
`;

export const LoadingPlaceholder: React.VFC<Props> = ({ testId }) => {
  return (
    <Column size={12} data-testid={testId}>
      <Wrapper>
        <DotLoadingIndicator />
      </Wrapper>
    </Column>
  );
};
